import {Injectable} from '@angular/core';
import {checkResponse} from '@app/shared/utils/app-utils';
import {Call, CallControlService, CallDto, CallLogEntry, ClickToCallResponse, TransferDto} from '@gt-api';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GtCallControlService {
  constructor(private callControlService: CallControlService) {}

  public transferCall(organization: string, login: string, caller: string, callee: string, transferee: string) {
    return new Observable(observer => {
      const dto = {
        caller,
        callee,
        transferee
      } as TransferDto;
      this.callControlService.transferCallWithDto1(organization, login, dto).subscribe(
        r => {
          if (r.code === 200) {
            if (r.transferred) {
              observer.next(r.manualHangupRequired);
              observer.complete();
            } else {
              /*
            exception contains transfer code:
            -1 = no calls found
            0 = OK
            1 = session not found
            2 = session already transferred
            3 = target busy
            4 = fraud
             */

              observer.error(r.exception);
            }
          } else {
            observer.error(r.message);
          }
        },
        e => observer.error(e.message)
      );
    });
  }

  public getActiveCalls(organization?: string, login?: string): Observable<Array<Call>> {
    return new Observable(observer => {
      this.callControlService.getActiveCalls2(organization, login).subscribe(
        r => {
          if (r.code !== 200) {
            observer.error(r.message);
          }
          observer.next(r.calls);
          observer.complete();
        },
        e => observer.error(e.message)
      );
    });
  }

  public clickToCall(organization?: string, login?: string, caller?: string, callee?: string): Observable<ClickToCallResponse> {
    return this.callControlService.clickToCall2(organization, login, caller, callee);
  }

  public clickToCallExtended(
    organization?: string,
    login?: string,
    mainNumber?: string,
    queueId?: string,
    agent?: string,
    callee?: string,
    displayNumber?: string
  ): Observable<ClickToCallResponse> {
    return this.callControlService.clickToCallExtended1(organization, login, mainNumber, queueId, agent, callee, displayNumber);
  }

  public clickToCallWithDisplayNumber(
    organization?: string,
    login?: string,
    caller?: string,
    callee?: string,
    displayNumber?: string
  ): Observable<ClickToCallResponse> {
    return this.callControlService.clickToCallWithDisplayNumber1(organization, login, caller, callee, displayNumber);
  }

  public clickToCallWithDto(organization?: string, login?: string, body?: CallDto): Observable<ClickToCallResponse> {
    return this.callControlService.clickToCallWithDto1(organization, login, body);
  }

  public connectAtoC(organization?: string, login?: string): Observable<any> {
    return this.callControlService.connectAtoC1(organization, login);
  }

  // From and To?, what time range?
  public getEndUserCallLog(): Observable<CallLogEntry[]> {
    return this.callControlService.getEndUserCallLog1().pipe(
      checkResponse(),
      map(r => r.callLog)
    );
  }
}
